import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-visit-day-element',
  templateUrl: './visit-day-element.component.html',
  styleUrls: ['./visit-day-element.component.scss'],
})
export class VisitDayElementComponent implements OnInit, OnDestroy {
  @ViewChild('popover') popover;
  @Input() visit: any = {};
  @Input() date: string;
  @Input() dayNumber: string;
  @Input() idVisit: string;
  @Input() jobs: [];
  @Input() visitObject: any;
  @Input() timesheetLabels: any;
  @Input() scoreStatusLabels: any;
  @Input() dateStarted: boolean;
  @Input() dateEnded: boolean;
  @Input() isPaused: boolean;
  @Input() accordionGroupId: string;
  @Input() accordionId: string;
  @Input() initiallyOpen = false;

  public showItemList = false;
  time: string;
  location: string;
  isOpen = false;
  googleMapsUrl = 'https://www.google.com/maps/dir/';
  hours: number;
  minutes: number;
  singleModule: any = null;
  private destroyed$ = new Subject<void>();

  constructor(
    private router: Router,
    private accordionService: AccordionService
  ) {}

  ngOnInit(): void {
    // Keep the idVisit that was passed in (visitId), don't overwrite it
    // this.idVisit = this.visitObject.id;

    // Register with accordion service if configuration is provided
    if (this.accordionGroupId && this.accordionId) {
      this.accordionService
        .registerItem(
          this.accordionId,
          this.accordionGroupId,
          this.initiallyOpen
        )
        .pipe(takeUntil(this.destroyed$))
        .subscribe((item) => {
          this.showItemList = item.isOpen;
        });
    }

    if (this.visit.visitTypeTab === 2) {
      if (!this.visit.plannedStartTime) {
        this.time = '';
      } else if (!this.visit.plannedEndTime) {
        this.time = this.visit.plannedStartTime;
      } else {
        this.time = `${this.visit?.plannedStartTime} - ${this.visit?.plannedEndTime}`;
      }
    } else {
      this.time = this.visit.inspectionTime;
    }

    this.location =
      this.visit.visitTypeTab === 2
        ? this.visit?.locationName
        : this.visit?.location;

    if (this.visit.visitDurationMinutes % 60 === 0) {
      this.hours = this.visit.visitDurationMinutes / 60;
      this.minutes = 0;
    } else {
      this.hours = Math.floor(this.visit.visitDurationMinutes / 60);
      this.minutes = this.visit.visitDurationMinutes % 60;
    }

    if (
      this.visit.modules &&
      this.visit.modules.length > 0 &&
      this.visit.visitType === 'J'
    ) {
      const firstModuleName = this.visit.modules[0].moduleName;
      const allSameModuleName = this.visit.modules.every(
        (module) => module.moduleName === firstModuleName
      );

      if (allSameModuleName) {
        const totalCnt = this.visit.modules.reduce(
          (sum, module) => sum + module.cnt,
          0
        );
        this.singleModule = {
          moduleName: firstModuleName,
          cnt: totalCnt,
        };
      }
    }
  }

  ngOnDestroy(): void {
    if (this.accordionId) {
      this.accordionService.unregisterItem(this.accordionId);
    }
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public toggleItemList(): void {
    if (this.accordionGroupId && this.accordionId) {
      this.accordionService.toggleItem(this.accordionId);
    } else {
      // Fallback behavior if no accordion configuration
      this.showItemList = !this.showItemList;
    }
  }

  showItems() {
    this.showItemList = !this.showItemList;
  }

  call(phoneNumber: string) {
    if (phoneNumber) {
      window.open(`tel:${phoneNumber}`);
    }
  }
  generateRouteLink() {
    let url = this.googleMapsUrl;

    if (this.visit.locationLat && this.visit.locationLng) {
      url += `/${this.visit.locationLat},${this.visit.locationLng}`;
      window.open(encodeURI(url), '_system', 'location=no');
    }
  }

  generateLinkToLocation() {
    const url = `https://maps.google.com/?q=${this.visit?.locationAddress},${this.visit?.locationCity},${this.visit?.locationPostCode}`;
    window.open(encodeURI(url), '_system', 'location=no');
  }
  generateLinkOnward() {
    const startIndex = this.jobs.findIndex(
      (obj: any) => obj.planningID === this.visit.planningID
    );
    if (startIndex !== -1) {
      // Element with the specified id found
      const destinationArray = this.jobs.slice(startIndex);
      let url = this.googleMapsUrl;
      destinationArray.forEach((visit: any) => {
        if (visit.locationLat && visit.locationLng) {
          url += `/${visit.locationLat},${visit.locationLng}`;
        }
      });

      window.open(encodeURI(url), '_system', 'location=no');
    }
  }

  routeToDetails() {
    this.router.navigate([
      'visitday/details',
      this.date,
      this.visit?.visitId,
      this.dayNumber,
    ]);
  }

  presentPopover(e: Event) {
    this.popover.event = e;
    this.isOpen = true;
  }
}
